import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { COMPANY, SERVICES, AREAS } from "@/lib/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-brand-ink text-white" data-testid="site-footer">
      <div className="container-lf py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-6">
          <div className="flex items-center gap-3">
            <img src="/logo-dark.png" alt="L F Building & Maintenance Ltd" className="h-40 md:h-48 w-auto" />
          </div>
          <p className="text-white/70 leading-relaxed max-w-md">
            Family-run builders delivering premium residential builds, extensions, roofing, lofts, kitchens and bathrooms across Essex and Suffolk since 2022.
          </p>
          <div className="space-y-3 text-sm">
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-3 hover:text-brand transition-colors" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-brand" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-brand transition-colors" data-testid="footer-email">
              <Mail className="w-4 h-4 text-brand" /> {COMPANY.email}
            </a>
            <div className="flex items-center gap-3 text-white/70">
              <MapPin className="w-4 h-4 text-brand" /> {COMPANY.areas}
            </div>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display uppercase text-sm tracking-[0.24em] mb-6 text-white/50">Services</h4>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="text-sm hover:text-brand transition-colors flex items-center gap-2 group">
                  <span>{s.name}</span>
                  <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display uppercase text-sm tracking-[0.24em] mb-6 text-white/50">Service Areas</h4>
          <div className="flex flex-wrap gap-2">
            {AREAS.map((a) => (
              <span key={a} className="text-xs px-3 py-1 border border-white/20 hover:border-brand hover:text-brand transition-colors cursor-default">
                {a}
              </span>
            ))}
          </div>
          <h4 className="font-display uppercase text-sm tracking-[0.24em] mt-8 mb-4 text-white/50">Opening Hours</h4>
          <p className="text-sm text-white/70">{COMPANY.hours}</p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-lf py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 uppercase tracking-wider">
            © {year} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-white/50 uppercase tracking-wider">
            {COMPANY.established} · Registered in England &amp; Wales
          </p>
        </div>
      </div>
    </footer>
  );
}
